module.exports = __webpack_public_path__ + "753b71f7760c093ef813ed1ec314d88f.svg";